// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3e1Um","question":"Question_question__3ufsW","description":"Question_description__6jowW"};